
import React from 'react';
import styled from 'styled-components';
import CustomApiViewer from './CustomApiViewer';
import yaml from 'js-yaml';

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  background-color: white;
  z-index: 1100;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  background: rgba(0,0,0,0.1);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 18px;
  cursor: pointer;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(0,0,0,0.2);
  }
`;

const IFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const PreviewModal = ({ spec, onClose, type }) => {
  const getHtmlContent = () => {
    try {
      const parsed = yaml.load(spec);
      
      if (type === 'swagger') {
        return `<!DOCTYPE html>
<html>
<head>
  <link rel="stylesheet" type="text/css" href="https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui.css" />
</head>
<body>
  <div id="swagger-ui"></div>
  <script src="https://unpkg.com/swagger-ui-dist@5.9.0/swagger-ui-bundle.js"></script>
  <script>
    window.onload = () => {
      SwaggerUIBundle({
        spec: ${JSON.stringify(parsed)},
        dom_id: '#swagger-ui',
        presets: [SwaggerUIBundle.presets.apis, SwaggerUIBundle.presets.standalone]
      });
    };
  </script>
</body>
</html>`;
      } else if (type === 'elements') {
        return `<!DOCTYPE html>
<html>
<head>
  <script src="https://unpkg.com/@stoplight/elements@7.15.0/web-components.min.js"></script>
  <link rel="stylesheet" href="https://unpkg.com/@stoplight/elements@7.15.0/styles.min.css">
</head>
<body>
  <elements-api id="docs" router="hash" layout="sidebar"></elements-api>
  <script>
    setTimeout(() => {
      const el = document.getElementById('docs');
      el.apiDescriptionDocument = JSON.stringify(${JSON.stringify(parsed)});
    }, 100);
  </script>
</body>
</html>`;
      } else if (type === 'redoc') {
        return `<!DOCTYPE html>
<html>
<head>
  <script src="https://cdn.redoc.ly/redoc/latest/bundles/redoc.standalone.js"></script>
</head>
<body>
  <div id="redoc-container"></div>
  <script>
    window.onload = () => {
      Redoc.init(${JSON.stringify(parsed)}, {}, document.getElementById('redoc-container'));
    };
  </script>
</body>
</html>`;
      } else if (type === 'rapidoc') {
        return `<!DOCTYPE html>
<html>
<head>
  <script type="module" src="https://unpkg.com/rapidoc/dist/rapidoc-min.js"></script>
</head>
<body>
  <rapi-doc id="thedoc" theme="light" render-style="read" spec-url="data:application/json;base64,${btoa(JSON.stringify(parsed))}"></rapi-doc>
</body>
</html>`;
      } else if (type === 'scalar') {
        return `<!DOCTYPE html>
<html>
<head>
  <title>Scalar API Reference</title>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
</head>
<body>
  <script id="api-reference" type="application/json">
    ${JSON.stringify(parsed)}
  </script>
  <script src="https://cdn.jsdelivr.net/npm/@scalar/api-reference"></script>
</body>
</html>`;
      }
    } catch (e) {
      return `<html><body><h1>Error loading preview</h1><pre>${e.message}</pre><p>Type: ${type}</p></body></html>`;
    }
  };

  if (type === 'custom') {
    try {
      const parsed = yaml.load(spec);
      return (
        <>
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050 }} onClick={onClose} />
          <Modal>
            <CloseButton onClick={onClose}>&times;</CloseButton>
            <CustomApiViewer spec={parsed} darkMode={false} />
          </Modal>
        </>
      );
    } catch (e) {
      return null;
    }
  }

  return (
    <>
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1050 }} onClick={onClose} />
      <Modal>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <IFrame srcDoc={getHtmlContent()} />
      </Modal>
    </>
  );
};

export default PreviewModal;
